import type TableViewConversationRelation from '../store/schema/TableViewConversationRelation';
import updateParentFolderIdInTableConversationRelation from '../actions/updateParentFolderIdInTableConversationRelation';
import { mutator } from 'satcheljs';

export default mutator(
    updateParentFolderIdInTableConversationRelation,
    function (actionMessage: {
        tableViewConversationRelation: TableViewConversationRelation;
        parentFolderId: string;
    }) {
        const { tableViewConversationRelation, parentFolderId } = actionMessage;
        tableViewConversationRelation &&
            (tableViewConversationRelation.parentFolderId = parentFolderId);
    }
);
